import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from '../../constant'
import axios from 'axios'

/**
 * FETCH DETAILS    
 * Create an async thunk to fetch the banners
 */
 
export const fetchHeroBanners = createAsyncThunk('banner/fetchHeroBanners', async (_, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + '/banners/web-carousel', {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});